export default {
  getPropertyAddress: state => {
    return state.propertyAddress;
  },
  getIsPropertySelected: state => {
    return state.isPropertySelected;
  },
  getApplicantInformation: state => {
    return state.applicantInformation;
  },
  getProductDetails: state => {
    return state.productDetails;
  },
  getTaxAdjustmentOrderId: state => {
    return state.taxAdjustmentOrderId;
  },
  getTaxAdjustmentDetails: state => {
    return state.taxAdjustmentDetails;
  },
  getApplicationType: state => {
    return state.applicationType;
  },
  getErrors: state => {
    return state.errors;
  },
  getPostOrderDetails: state => {
    return state.postOrderDetails;
  },
  getReasonConfigurations: state => {
    return state.reasonConfigurations;
  }
};
